export default "__VITE_ASSET__BYix439O__"